import { useMemo } from 'react';
import { formatFileSize } from '../utils/CommonUtils';

export const useTableColumns = (formatDateTime) => {
  const tableColumns = useMemo(() => [
    {
      accessorKey: 'filename',
      header: 'Filename',
    },
    {
      accessorKey: 'datetime',
      header: 'Created on Device',
      Cell: ({ cell }) => formatDateTime(cell.getValue()),
    },
    {
      accessorKey: 'datetime_upload',
      header: 'Uploaded to Cloud',
      Cell: ({ cell }) => formatDateTime(cell.getValue()),
    },
    {
      accessorFn: (row) => row.category || row.file_type,
      id: 'category_or_type',
      header: 'Type/Category',
      size: 120,
    },
    {
      accessorKey: 'file_size',
      header: 'Size',
      Cell: ({ cell }) => formatFileSize(cell.getValue()),
      sortingFn: (rowA, rowB) => {
        const a = parseInt(rowA.original.file_size, 10) || 0;
        const b = parseInt(rowB.original.file_size, 10) || 0;
        return a - b;
      },
    },
  ], [formatDateTime]);

  return {
    tableColumns,
  };
};